module.exports = __webpack_public_path__ + "img/system_hover.dc63cff7.png";